import React from "react";
import { Helmet } from "react-helmet";
import { LocalesSliceFragment } from "../../types/graphql";

export interface ILocalesProps {
  northAmericaHref?: string;
  items?: LocalesSliceFragment["items"];
}

const northAmericaHrefLangs = ["en-us", "en-ca", "en", "x-default"];
const euroEnglish = "English (Europe)";
const asiaEnglish = "English (Asia)";
const otherLangs = [
  { name: "English (Great Britain)", code: "en-gb" },
  { name: "English (Australia)", code: "en-au" },
  { name: "Arabic", code: "ar" },
  { name: "Bulgarian", code: "bg" },
  { name: "Chinese (Simplified)", code: "zh-hans" },
  { name: "Croatian", code: "hr" },
  { name: "Czech", code: "cs" },
  { name: "Danish", code: "da" },
  { name: "Dutch", code: "nl" },
  { name: "Finnish", code: "fi" },
  { name: "French", code: "fr" },
  { name: "German", code: "de" },
  { name: "Greek", code: "el" },
  { name: "Hungarian", code: "hu" },
  { name: "Italian", code: "it" },
  { name: "Norwegian", code: "no" },
  { name: "Polish", code: "pl" },
  { name: "Portuguese", code: "pt" },
  { name: "Romanian", code: "ro" },
  { name: "Slovak", code: "sk" },
  { name: "Slovenian", code: "sl" },
  { name: "Spanish", code: "es" },
  { name: "Spanish (Spain)", code: "es-es" },
  { name: "Swedish", code: "sv" },
  { name: "Turkish", code: "tr" },
  { name: euroEnglish, code: "en-at" },
  { name: euroEnglish, code: "en-be" },
  { name: euroEnglish, code: "en-ch" },
  { name: euroEnglish, code: "en-cz" },
  { name: euroEnglish, code: "en-de" },
  { name: euroEnglish, code: "en-dk" },
  { name: euroEnglish, code: "en-fi" },
  { name: euroEnglish, code: "en-fr" },
  { name: euroEnglish, code: "en-gr" },
  { name: euroEnglish, code: "en-hu" },
  { name: euroEnglish, code: "en-hr" },
  { name: euroEnglish, code: "en-ie" },
  { name: euroEnglish, code: "en-is" },
  { name: euroEnglish, code: "en-it" },
  { name: euroEnglish, code: "en-lu" },
  { name: euroEnglish, code: "en-no" },
  { name: euroEnglish, code: "en-nl" },
  { name: euroEnglish, code: "en-pl" },
  { name: euroEnglish, code: "en-pt" },
  { name: euroEnglish, code: "en-ro" },
  { name: euroEnglish, code: "en-se" },
  { name: euroEnglish, code: "en-tr" },
  { name: euroEnglish, code: "en-ad" },
  { name: euroEnglish, code: "en-al" },
  { name: euroEnglish, code: "en-ba" },
  { name: euroEnglish, code: "en-bg" },
  { name: euroEnglish, code: "en-cy" },
  { name: euroEnglish, code: "en-ee" },
  { name: euroEnglish, code: "en-li" },
  { name: euroEnglish, code: "en-lt" },
  { name: euroEnglish, code: "en-lv" },
  { name: euroEnglish, code: "en-mc" },
  { name: euroEnglish, code: "en-md" },
  { name: euroEnglish, code: "en-me" },
  { name: euroEnglish, code: "en-mk" },
  { name: euroEnglish, code: "en-mt" },
  { name: euroEnglish, code: "en-rs" },
  { name: euroEnglish, code: "en-si" },
  { name: euroEnglish, code: "en-sk" },
  { name: euroEnglish, code: "en-sm" },
  { name: asiaEnglish, code: "en-cn" },
  { name: asiaEnglish, code: "en-nz" },
  { name: asiaEnglish, code: "en-kr" },
  { name: asiaEnglish, code: "en-sg" },
  { name: asiaEnglish, code: "en-jp" },
];

export const Locales = (props: ILocalesProps) => {
  const { items, northAmericaHref } = props;
  const langToHrefs: { hrefLang: string; href: string }[] = [];

  // North American hrefLangs
  if (northAmericaHref) {
    northAmericaHrefLangs.forEach((northAmericaHrefLang) => {
      langToHrefs.push({
        hrefLang: northAmericaHrefLang,
        href: northAmericaHref,
      });
    });
  }

  // European and Asian hrefLangs
  items?.forEach((localeSliceItem) => {
    otherLangs
      .filter((language) => {
        return language.name === localeSliceItem?.locale;
      })
      .forEach((languageInTheSlice) => {
        if (localeSliceItem?.page?.url && languageInTheSlice?.code) {
          langToHrefs.push({
            hrefLang: languageInTheSlice.code,
            href: localeSliceItem.page.url,
          });
        }
      });
  });

  return (
    <Helmet>
      {langToHrefs.map((langToHref, index) => {
        return (
          <link
            key={index}
            rel="alternate"
            hrefLang={langToHref.hrefLang}
            href={langToHref.href}
          />
        );
      })}
    </Helmet>
  );
};
